/**
 * Hand a Blob to the browser as a file to save, under `filename`. The object
 * URL is kept a minute: a browser that asks where to save still finds it.
 * Shared by the document reader and the snapshot dialog.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 60_000);
}
